import { TransactionAmount } from './TransactionAmount';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import { Chip, Typography } from '@heroui/react';
import type { SalesTransaction } from '@/api/models';
import { getNodeTestIdProp } from '@/utils';
import { isDiscountedTransaction } from './transactionsMeta';

type TransactionTotalProps = { transaction: SalesTransaction };
export const TransactionTotal = ({ transaction }: TransactionTotalProps) => {
    const { t } = useTranslation('pages');
    return (
        <div className="flex flex-col items-end gap-1">
            <Typography weight="bold" type="body-sm">
                <span
                    {...getNodeTestIdProp(
                        'transactions-row-total-' + transaction.id,
                    )}
                >
                    <TransactionAmount amountTetri={transaction.totalTetri} />
                </span>
            </Typography>
            {isDiscountedTransaction(transaction) && (
                <Chip
                    color="default"
                    variant="tertiary"
                    size="sm"
                    {...getNodeTestIdProp(
                        'transactions-row-discount-' + transaction.id,
                    )}
                >
                    <Icon
                        aria-hidden="true"
                        icon="gravity-ui:tag"
                        className="size-3 shrink-0"
                    />
                    <Chip.Label>
                        {t('sales.widgets.transactions.discountPrefix')}{' '}
                        <TransactionAmount
                            amountTetri={transaction.discountTotalTetri}
                            minus
                        />
                    </Chip.Label>
                </Chip>
            )}
        </div>
    );
};
